// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'

import App from './App.vue'
import router from './router'
import store from './store/'
import { VueAxios } from './utils/request'
import { Pagination, Descriptions } from 'ant-design-vue'
import { Tree } from 'view-design'
import VueViewer from 'v-viewer'
import global from './config/global'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import './icons'
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'
import './components/styles.less'
import 'viewerjs/dist/viewer.css'
// 引入样式表
import 'ant-design-vue/dist/antd.css'
// mock
// WARNING: `mockjs` NOT SUPPORT `IE` PLEASE DO NOT USE IN `production` ENV.
// import './mock'

// import bootstrap from './core/bootstrap'
// import initStore from './core/initStore'
import './core/lazy_use'
// import './core/mixins'
import './permission' // permission control
import './utils/filter' // global filter
import './components/global.less'
import './components/global.stylus'
import './styles/bplayer-speed.less'
import 'view-design/dist/styles/iview.css'

import VueQuillEditor from 'vue-quill-editor'
import SitesEditorSpin from './components/SitesEditorSpin/SitesEditorSpin.vue'
import VideoPlayer from 'vue-video-player'

require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// initStore(store)
Vue.use(VideoPlayer)
Vue.use(VueQuillEditor)
Vue.use(Descriptions)
Vue.use(VueViewer)

Vue.component(Pagination.name, Pagination)
Vue.component('SitesEditorSpin', SitesEditorSpin)
Vue.component('Tree', Tree)
Vue.config.productionTip = false
Vue.prototype.$global = global
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)
// mount axios Vue.$http and this.$http
Vue.use(VueAxios)

new Vue({
  router,
  store,
  // created: bootstrap,
  // created: initStore(store),
  render: h => h(App)
}).$mount('#app')
